import { findWidgetByVar } from "./primefaces-util.ts";

/**
 * Utility function to start polling for a PrimeFaces component.
 * @param widgetVar The widget variable of the PrimeFaces component to start polling for.
 * @param delayMs The delay in milliseconds before starting the polling.
 */
export function startPollingDelayed(widgetVar: string, delayMs: number): void {
  const tryStart = () => {
    const widget = findWidgetByVar(widgetVar, PrimeFaces.widget.Poll);
    if (widget) {
      widget.start();
    } else {
      setTimeout(tryStart, 200);
    }
  };
  setTimeout(tryStart, delayMs);
}
